// File: cgp-api.ts
// Author: Joseph M Diaz
// Date: 5/12/2017
// Desc: Api class that handles common code during ajax requests.
// Other Contributors:

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { cgpAuthentication } from './cgp-authentication';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CgpApiService {
    constructor(private http: HttpClient) { }

    private beforeSend(opts) {
        // do common stuff here such as adding the cgp token to each request
        //

        const headers = new Headers({ 'Content-Type': 'application/json' });
        const localToken = cgpAuthentication.getAuthToken();

        if (!localToken || localToken.length === 0) {
            window.location.replace('#/logged-out');
            return {
                opts: null,
                error: 'Auth token is not valid.'
            }
        }
        else {
            headers.append("Authorization", localToken);
        }

        return {
            opts: {
                ...opts,
                headers: headers
            },
            error: null
        }
    }

    private beforeError() {
        // do common stuff here
        //
    }

    private beforeComplete() {
        // do common stuff here
        //
    }

    get(url, opts) {
        const beforeSendResult = this.beforeSend(opts);

        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                this.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                this.http.get(url, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            this.beforeError();
                            observer.error(error);
                        },
                        () => {
                            this.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    post(url, body, opts) {
        const beforeSendResult = this.beforeSend(opts);

        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                this.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                this.http.post(url, body, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            this.beforeError();
                            observer.error(error);
                        },
                        () => {
                            this.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    put(url, body, opts) {
        const beforeSendResult = this.beforeSend(opts);

        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                this.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                this.http.put(url, body, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            this.beforeError();
                            observer.error(error);
                        },
                        () => {
                            this.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    delete(url, opts) {
        const beforeSendResult = this.beforeSend(opts);

        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                this.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                this.http.delete(url, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            this.beforeError();
                            observer.error(error);
                        },
                        () => {
                            this.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }
}
